export default __webpack_public_path__ + "static/media/liberum-11.7d136057.png";